import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

const Loader = props => {
  const loading = useSelector(state => state.performance.loading);
  return (
    <div>
      {loading && (
        <div className="box">
          <div className="loader"></div>
        </div>
      )}
    </div>
  );
};

export default Loader;
